import { useSuspenseQuery } from "@tanstack/react-query";
import React from "react";
import { useLoaderData } from "react-router";

import type { InsightsLoaderReturn } from "../loader";
import { insightsRouteDataQuery } from "../utils/route-data-query";

import Placeholder from "./placeholder";

export default function withPlaceholderFallback<TProps extends JSX.IntrinsicAttributes>(
  ComponentToRender: React.FC<TProps>
): React.FC<TProps> {
  return (props) => {
    const { customerDomain }: InsightsLoaderReturn = useLoaderData();
    const {
      data: { hasWorkflowCompleted },
    } = useSuspenseQuery(insightsRouteDataQuery(customerDomain));
    if (!hasWorkflowCompleted) {
      return <Placeholder />;
    }
    return <ComponentToRender {...props} />;
  };
}
